<div class="slideout-content">
    <!-- Modal to add new project starts-->
    <div class="modalsd modal-slide-in sdfade new-project-modal" id="modals-slide-in">
        {{data}}

        <div class="modal-dialog">
            <form class="add-new-project modal-content pt-0" [formGroup]="projectForm">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-project')">
                    ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">Proje {{data ? 'Güncelle' :'Ekle'}}</h5>
                </div>
                <div class="modal-body flex-grow-1">

                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="projectName">Proje Adı</label>
                            <input type="text" formControlName="projectName" class="form-control"
                                placeholder="Proje Adı Giriniz." />
                            <div
                                *ngIf="projectForm.get('projectName').invalid && (projectForm.get('projectName').dirty || projectForm.get('projectName').touched)">
                                <small class="text-danger" *ngIf="projectForm.get('projectName').errors.required">Proje
                                    adı
                                    zorunludur.</small>
                                <small class="text-danger" *ngIf="projectForm.get('projectName').errors.maxlength">Proje
                                    adı en fazla 100
                                    karakter olabilir.</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="description">Açıklama</label>
                            <textarea formControlName="description" class="form-control"
                                placeholder="Proje Açıklaması Giriniz."></textarea>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="budget">Proje Bütçe Fiyatı</label>
                            <input type="number" formControlName="budget" class="form-control"
                                placeholder="Bütçe Giriniz." value="0" />
                        </div>
                    </div>
                    <div class="col-12 mb-1" *ngIf="data != null">
                        <div class="form-group">
                            <ng-select [items]="status" bindLabel="name" bindValue="id"
                                formControlName="status"></ng-select>
                        </div>
                    </div>
                    <div class="col-12">
                        <button type="submit" [disabled]="projectForm.invalid" class="btn btn-primary col-12 mb-1"
                            *ngIf="hasPermission()" (click)="data ? onUpdate() : onSubmit()" rippleEffect>{{data ?
                            'Güncelle' :
                            'Ekle'}}
                        </button>
                    </div>
                    <div class="col-12">
                        <button type="reset" class="btn btn-outline-secondary col-12 mb-1"
                            (click)="toggleSidebar('create-project')" rippleEffect>
                            İptal
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new project Ends-->
</div>